import React from 'react';
import { DateTime, Numberbox, ValidationProps } from 'ui';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { parseAsDateUTC, createUTCDate, dateToUTC, createFormatters } from 'app/infrastructure/data/date';
import { SavedReportsEndpoints } from 'app/area/shared/saved-reports/constants';

import { DashboardAdminTranslation } from '../../constants';
import { SavedReportDashboard } from '../types-store';
import { SavedReportPicker } from './saved-report-picker';

interface SavedReportFormProps {
  savedReport: SavedReportDashboard;

  updateCurrent: (savedReport: Partial<SavedReportDashboard>) => void;

  endpoints: SavedReportsEndpoints;

  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    };
  };
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;

  locale: string;
  validation: { [T in keyof SavedReportDashboard]?: ValidationProps };
  translation: DashboardAdminTranslation;
}

const disabledId = 'disabled';
const minWidth = 'minWidth';
const height = 'height';

export const SavedReportForm: React.FC<SavedReportFormProps> = ({
  savedReport, updateCurrent,
  endpoints, options, loadOptions,
  locale, validation, translation
}) => {

  const onDisabledChange = (value: Date) => {
    updateCurrent({ disabled: value });
  };

  const onMinWidthChange = (value: number) => {
    updateCurrent({ minWidth: value });
  };

  const onHeightChange = (value: number) => {
    updateCurrent({ height: value });
  };

  return <>
    {(!savedReport?.code?.description || !!validation?.code) && <SavedReportPicker
      valueItem={savedReport?.code}
      updateCurrent={updateCurrent}
      endpoints={endpoints}
      options={options}
      loadOptions={loadOptions}
      locale={locale}
      validation={validation}
      translation={translation} />}
    <div className="row">
      <div className="col-lg-6 col-sm-12">
        <Numberbox
          componentId={minWidth}
          label={translation ? { text: translation.minWidth, required: true } : undefined}
          value={savedReport?.minWidth}
          onChange={onMinWidthChange}
          useThousand=" "
          maxValue={9999}
          locale={locale}
          validation={validation?.minWidth}
        />
      </div>
      <div className="col-lg-6 col-sm-12">
        <Numberbox
          componentId={height}
          label={translation ? { text: translation.height } : undefined}
          value={savedReport?.height}
          onChange={onHeightChange}
          useThousand=" "
          maxValue={9999}
          locale={locale}
          validation={validation?.height}
        />
      </div>
    </div>
    <div className="row">
      <div className="col-lg-6 col-sm-12">
        <DateTime
          componentId={disabledId}
          className="dateTime"
          value={savedReport?.disabled}
          label={translation ? { text: translation.disabled } : undefined}
          useTime={false}
          parseDate={parseAsDateUTC}
          createDate={createUTCDate}
          cloneDate={dateToUTC}
          {...createFormatters(locale)}
          locale={locale}
          onChange={onDisabledChange}
          captionWrapper={'form'}
          validation={validation?.disabled}
        />
      </div>
    </div>
  </>;
};
